<template>
    <div :class="mainClass">
        <span :class="activeClass">{{ rank || '' }}</span>
        <span class="scc-team-rank-block__name-container">
            <p class="scc-team-rank-block__name">{{ name }}</p>
        </span>
        <div class="scc-team-rank-block__spacer"></div>
        <span class="scc-team-rank-block__amount-container">
            <p class="scc-team-rank-block__amount">{{ amount }} loten</p>
        </span>
        <template v-if="showLink && slug">
            <div class="scc-team-rank-block__spacer"></div>
            <span class="scc-team-rank-block__link-container">
                <SccLink class="scc-team-rank-block__link" :to="slug">Loten kopen <arrow-right /></SccLink>
            </span>
        </template>
    </div>
</template>

<script>
import './team-rank-block.scss';
import arrowRight from '../../assets/icons/arrow-right.vue';

export default {
    name: 'TeamRankBlock',
    components: { arrowRight },
    props: {
        rank: {
            type: Number,
        },
        name: {
            type: String,
            default: 'Team paragraph',
        },
        amount: {
            type: Number,
            default: 0,
        },
        slug: {
            type: String,
        },
        active: {
            type: Boolean,
            default: false,
        },
        customClass: {
            type: String,
            default: '',
        },
        showLink: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        mainClass() {
            const baseClass = 'scc-team-rank-block';
            if (!this.customClass || this.customClass == '') return baseClass;

            return baseClass + ' ' + this.customClass;
        },
        activeClass() {
            const baseClass = 'scc-team-rank-block__ranking';
            if (!this.active) return baseClass;

            return baseClass + ' scc-team-rank-block__ranking--active';
        },
    },
};
</script>
